// src/suppressErrors.ts

// Suppress ResizeObserver errors
const resizeObserverErrSuppressor = (e: ErrorEvent) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
};

window.addEventListener('error', resizeObserverErrSuppressor);

// Suppress in console too
const originalError = console.error;
console.error = (...args: any[]) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver')
  ) {
    return;
  }
  originalError.apply(console, args);
};

// Remove known dev-overlay DOM nodes if they appear so no visual overlay
// is shown anywhere while preserving console logs and global handlers
const overlaySelectors = [
  '.react-error-overlay',
  '#webpack-dev-server-client-overlay',
  '.webpack-dev-server-client-overlay',
  '.dev-overlay',
];

function removeExistingOverlays() {
  overlaySelectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => el.remove());
  });
}

// Run once on load
try {
  if (typeof document !== 'undefined') {
    removeExistingOverlays();

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          for (const sel of overlaySelectors) {
            try {
              if (node.matches && node.matches(sel)) {
                node.remove();
                return;
              }
            } catch (err) {
              // ignore matching errors
            }
            // Also check children
            (node as Element).querySelectorAll?.(sel).forEach((el) => el.remove());
          }
        });
      }
    });

    observer.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true,
    });
  }
} catch (err) {
  // ignore errors in suppress logic
}

export {};